import { render, staticRenderFns } from "./CardFoodDiaryMain.vue?vue&type=template&id=e64baa5c"
import script from "./CardFoodDiaryMain.vue?vue&type=script&lang=js"
export * from "./CardFoodDiaryMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports